import commonFunc from "../common.func";
import constant from "../main.constants";

const P = constant.PERMISSIONS;

const isKycV2Available = () => commonFunc.isKycV2Enabled();

const kycV2Guard = (...perms) => (to, from, next) => {
  if (!isKycV2Available()) {
    next({ name: "Home" });
    return;
  }
  if (commonFunc.checkPermissionWithName(P.admin)) {
    next();
    return;
  }
  if (perms.some((p) => commonFunc.checkPermissionWithName(p))) {
    next();
    return;
  }
  next({ name: "Forbidden" });
};

// KYC v2 (dinamik: kural/onboarding/incident/onay) route'ları.
export default [
  {
    path: "/kycRuleList",
    name: "KycRuleList",
    component: () => import("../views/KycRuleList.vue"),
    beforeEnter: kycV2Guard(P.kycRule),
  },
  {
    path: "/kycRuleAnalysis/:queryId?",
    name: "KycRuleAnalysis",
    component: () => import("../views/KycRuleAnalysis.vue"),
    beforeEnter: kycV2Guard(P.kycRule),
  },
  {
    path: "/kycPendingApprovals",
    name: "KycPendingApprovals",
    component: () => import("../views/KycPendingApprovals.vue"),
    beforeEnter: kycV2Guard(P.kycApproval),
  },
  {
    path: "/kycOnboardingWizard",
    name: "KycOnboardingWizard",
    component: () => import("../views/KycOnboardingWizard.vue"),
    beforeEnter: kycV2Guard(P.kycConfig),
  },
  {
    path: "/kycIncidentManagementV2",
    name: "KycIncidentManagementV2",
    component: () => import("../views/KycIncidentManagementV2.vue"),
    beforeEnter: kycV2Guard(P.kycIncident),
  },
  {
    path: "/kycIncidentStates",
    name: "KycIncidentStates",
    component: () => import("../views/KycIncidentStateAdmin.vue"),
    beforeEnter: kycV2Guard(P.kycIncidentState),
  },
];
